// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1zCGN","left":"StickyBox_left__SQoqg","right":"StickyBox_right__1HFG-"};